import SignUp from "../components/SignUpModal/SignUp";

const User = ({ state = 'login', onLogin }) => {
    return (
        <div>
          <SignUp />
        </div>
    );
};

export default User;
